export default "__VITE_ASSET__CbjfO5Us__"